/**
 * Bread sidebar lightbox functionality
 */

export default {

	$links: [],

	$lightbox: null,

	init() {
		this.$links = document.querySelectorAll('.lightbox-link');
		this.$lightbox = document.querySelector('#sidebar-lightbox');

		if(!this.$links.length) return;

		for(const $link of this.$links) $link.addEventListener('click', e => this.open(e));

		this.$lightbox.addEventListener('click', e => this.close());
	},

	open(e) {
		e.preventDefault();

		this.$lightbox.classList.add('is-active');

		const targetSelector = e.currentTarget.getAttribute('href');
		const target = document.querySelector(targetSelector);

		target.classList.add('is-active');

		document.querySelector('body').classList.add('no-scroll');
	},

	close() {
		this.$lightbox.classList.remove('is-active');

		for(const $box of this.$lightbox.querySelectorAll('.lightbox-inner')) {
			$box.classList.remove('is-active');
		}

		document.querySelector('body').classList.remove('no-scroll');

		return false;
	}
}